import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import * as XLSX from "xlsx";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import "jspdf-autotable";

import Header from "../../components/header";
import Sidebar from "../../components/sidebar";
import Footer from "../../components/footer";
import Loader from "../../components/loader";

function LedgerReport() {
  const [orderData, setData] = useState([]);
  const today = new Date().toISOString().split("T")[0];
  const [eDate, setEDate] = useState(today);
  const [sDate, setSDate] = useState(today);
  const [loader, setLoader] = useState(false);
  const [filterdData, setFilteredData] = useState([]);

  const [dealerFilter, setDealerFilter] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [selectedRoutes, setSelectedRoutes] = useState(["all"]);
  const [allRoutes, setAllRoutes] = useState([]);
  console.log(selectedRoutes);

  const filterDealer = () => {
    const filterData = orderData?.filter((order) => {
      let dealerMatch = true;
      let routeMatch = true;

      // ✅ Dealer filter
      if (dealerFilter) {
        dealerMatch = order?.dealerData?.dealer
          ?.toLowerCase()
          .includes(dealerFilter.toLowerCase());
      }

      // ✅ Route filter
      if (selectedRoutes) {
        if (typeof selectedRoutes === "string") {
          // Single route (string)
          routeMatch = order?.routes
            ?.toLowerCase()
            .includes(selectedRoutes.toLowerCase());
        } else if (Array.isArray(selectedRoutes)) {
          if (selectedRoutes.includes("all")) {
            routeMatch = true;
          } else if (selectedRoutes.length > 0) {
            routeMatch = selectedRoutes.some((route) =>
              order?.routeName?.toLowerCase().includes(route.toLowerCase())
            );
          } else {
            routeMatch = false;
          }
        }
      }

      return dealerMatch && routeMatch;
    });

    console.log("filterData", filterData);
    setFilteredData(filterData);
  };

  useEffect(() => {
    filterDealer();
  }, [dealerFilter, selectedRoutes]);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleRouteSelection = (route) => {
    if (route === "all") {
      if (selectedRoutes.includes("all")) {
        setSelectedRoutes([]);
      } else {
        setSelectedRoutes(["all"]);
      }
    } else {
      if (selectedRoutes.includes(route)) {
        const updatedRoutes = selectedRoutes.filter((r) => r !== route);
        if (updatedRoutes.length === 0) {
          setSelectedRoutes(["all"]);
        } else {
          setSelectedRoutes(updatedRoutes.filter((r) => r !== "all"));
          filterDealer();
        }
      } else {
        const updatedRoutes = [
          ...selectedRoutes.filter((r) => r !== "all"),
          route,
        ];
        setSelectedRoutes(updatedRoutes);
        filterDealer();
      }
    }
  };

  const isRouteSelected = (route) => {
    return selectedRoutes.includes("all") || selectedRoutes.includes(route);
  };

  const formatDate = (date) => {
    const newDate = new Date(date);
    if (isNaN(newDate)) {
      console.error("Invalid date format");
      return;
    }

    const formattedDate = `${newDate.getFullYear()}-${String(
      newDate.getMonth() + 1
    ).padStart(2, "0")}-${String(newDate.getDate()).padStart(2, "0")}`;
    return formattedDate;
  };

  const formatViewDate = (date) => {
    const newDate = new Date(date);
    if (isNaN(newDate)) {
      console.error("Invalid date format");
      return;
    }

    const formattedDate = `${String(newDate.getDate()).padStart(
      2,
      "0"
    )}-${String(newDate.getMonth() + 1).padStart(
      2,
      "0"
    )}-${newDate.getFullYear()}`;
    return formattedDate;
  };

  const formatSendDate = (dateStr) => {
    const date = new Date(dateStr);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // months are 0-based
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}/${month}/${day}`;
  };

  const getData = async () => {
    setLoader(true);
    const sendData = {
      sDate: formatSendDate(sDate),
      eDate: formatSendDate(eDate),
    };

    try {
      const response = await axios.post(
        "https://api.trucoo.in/invoice/monthly-report/",
        sendData,
        {
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": "erpTrucoo",
          },
        }
      );

      if (response.data.status === "success") {
        console.log(response.data.data);
        setData(response.data.data);
        setFilteredData(response.data.data);
        const routes = [
          ...new Set(
            response.data.data
              .map((order) => order.routeName || "")
              .filter((r) => r)
          ),
        ];

        setAllRoutes(routes);
        console.log(routes);
      } else {
        console.log("Error fetching data");
        setData([]);
      }
    } catch (error) {
      console.error("Error:", error.response || error.message);
      setData([]);
    }
    setLoader(false);
  };

  // useEffect(() => {
  //     getData();
  // }, [sDate, eDate]);

  const getFiscalYearLabel = (date = new Date()) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    if (month < 3) {
      return `${(year - 1).toString().slice(-2)}-${year.toString().slice(-2)}`;
    } else {
      return `${year.toString().slice(-2)}-${(year + 1).toString().slice(-2)}`;
    }
  };

  const getGSTItem = (orderDatails, dealerDetails, type, product) => {
    const gstType = dealerDetails?.gstType;

    if (gstType === type && product === "milk") {
      let total = 0;

      orderDatails?.forEach((item) => {
        if (item?.itemType === "milk") {
          if (parseFloat(item?.itemGst) > 0) {
            const price = parseFloat(item.itemPrice);
            const gst = parseFloat(item.itemGst);
            const productGst = parseFloat(price - price / (1 + gst / 100));
            const productPrice = parseFloat(price - productGst);
            total +=
              parseFloat(
                parseFloat(productPrice) *
                  parseFloat(item?.qty) *
                  parseFloat(item?.itemGrade)
              ) || 0;
          } else {
            const price = parseFloat(item.itemPrice);
            total +=
              parseFloat(
                parseFloat(price) *
                  parseFloat(item?.qty) *
                  parseFloat(item?.itemGrade)
              ) || 0;
          }
        }
      });

      if (total > 0) {
        return parseFloat(total).toFixed(2);
      } else {
        return "";
      }
    } else if (gstType === type && product === "curd") {
      let total = 0;
      orderDatails?.forEach((item) => {
        if (item?.itemType === "curd") {
          if (parseFloat(item?.itemGst) > 0) {
            const price = parseFloat(item.itemPrice);
            const gst = parseFloat(item.itemGst);
            const productGst = parseFloat(price - price / (1 + gst / 100));
            const productPrice = parseFloat(price - productGst).toFixed(2);
            total +=
              parseFloat(productPrice) *
                (parseFloat(item?.qty) * parseFloat(item?.itemGrade)).toFixed(
                  2
                ) || 0;
          } else {
            const price = parseFloat(item.itemPrice);
            total +=
              parseFloat(
                parseFloat(price) *
                  parseFloat(item?.qty) *
                  parseFloat(item?.itemGrade)
              ).toFixed(2) || 0;
          }
        }
      });

      if (parseFloat(total) > 0) {
        return parseFloat(total).toFixed(2);
      } else {
        return "";
      }
    } else {
      return "";
    }
  };

  const getGstTotal = (orderDatails, dealerDetails, type) => {
    const gstType = dealerDetails?.gstType;

    if (gstType === type) {
      let total = 0;
      orderDatails?.forEach((item) => {
        if (item?.itemGst > 0) {
          const price = parseFloat(item.itemPrice);
          const gst = parseFloat(item.itemGst);
          const productGst = parseFloat(price - price / (1 + gst / 100));
          const productPrice = parseFloat(price - productGst).toFixed(2);
          total +=
            parseFloat(productPrice) *
              (parseFloat(item?.qty) * parseFloat(item?.itemGrade)).toFixed(
                2
              ) || 0;
        }
      });

      if (parseFloat(total) > 0) {
        return parseFloat(total).toFixed(2);
      } else {
        return "";
      }
    } else {
      return "";
    }
  };

  const getTotal = (orderDatails) => {
    let total = 0;
    orderDatails?.forEach((item) => {
      const price = parseFloat(item.itemPrice);
      const gst = parseFloat(item.itemGst);
      const productGst = parseFloat(price - price / (1 + gst / 100)) || 0;
      const productPrice = parseFloat(price - productGst).toFixed(2);
      total +=
        parseFloat(productPrice) *
          (parseFloat(item?.qty) * parseFloat(item?.itemGrade)).toFixed(2) || 0;
    });

    if (parseFloat(total) > 0) {
      return parseFloat(total).toFixed(2);
    } else {
      return "";
    }
  };

  const getGrandTotal = (orderDatails) => {
    let total = 0;
    orderDatails?.forEach((item) => {
      const price = parseFloat(item.itemPrice);
      const gst = parseFloat(item.itemGst);
      const productGst = parseFloat(price - price / (1 + gst / 100)) || 0;
      const productPrice = parseFloat(price - productGst);
      total +=
        parseFloat(productPrice) *
          (parseFloat(item?.qty) * parseFloat(item?.itemGrade)) || 0;
    });

    if (parseFloat(total) > 0) {
      return parseFloat(total).toFixed(2);
    } else {
      return "";
    }
  };

  const getWeight = (type, orderDatails) => {
    let totalWeight = 0;
    orderDatails?.forEach((item) => {
      if (item?.itemType === type) {
        totalWeight +=
          parseFloat(item?.itemWeight / 1000) *
            (parseFloat(item?.qty) * parseFloat(item?.itemGrade)) || 0;
      }
    });
    return totalWeight.toFixed(2);
  };

  const exportToExcel = () => {
    const ws = XLSX.utils.table_to_sheet(
      document.getElementById("printableArea")
    );
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Daily Sales Report");
    XLSX.writeFile(
      wb,
      `Daily_Sales_Report_${formatDate(sDate)}_${formatDate(eDate)}.xlsx`
    );
  };

  let igstMilkTotal = 0;
  let sgstMilkTotal = 0;
  let igstCurdTotal = 0;
  let sgstCurdTotal = 0;
  let netTotTotal = 0;
  let iGstTotal = 0;
  let sGstToatl = 0;
  let dicsTotal = 0;
  let grandTotTotal = 0;
  let milkWeightTotal = 0;
  let curdWeightTotal = 0;
  let roundOffTotal = 0;

  return (
    <>
      {loader && <Loader />}
      <Header />
      <Sidebar />

      <div className="content-wrapper">
        <div className="container-full">
          <section className="content">
            <div className="box">
              <div className="box-header with-border">
                <div className="row">
                  <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-12">
                    <h4 className="box-title">Monthly Sales Reports</h4>
                    <p className="mb-0 box-subtitle">Invoices</p>
                  </div>
                  <div className="row justify-content-end align-items-center">
                    <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-12">
                      <div className="input-group">
                        <input
                          type="date"
                          value={formatDate(sDate)}
                          onChange={(e) => setSDate(e.target.value)}
                          className="form-control"
                        />
                        <input
                          type="date"
                          value={formatDate(eDate)}
                          onChange={(e) => setEDate(e.target.value)}
                          className="form-control"
                        />
                        <button
                          className="btn btn-sm btn-success"
                          onClick={getData}
                        >
                          Get Report
                        </button>
                      </div>
                    </div>

                    <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-4 col-12">
                      <div className="dropdown" >
                        <button
                          className="form-control text-start"
                          onClick={toggleDropdown}
                          style={{ textAlign: "left" }}
                        >
                          {selectedRoutes.includes("all")
                            ? "All Routes"
                            : `${selectedRoutes.length} Routes Selected`}
                        </button>
                        {isOpen && (
                          <div
                            className="dropdown-menu show"
                            style={{ minWidth: "250px", padding: "8px", overflowX: 'scroll', maxHeight: '69vh'}}
                          >
                            <div className="mb-2 d-flex justify-content-between align-items-center border-bottom pb-2">
                              <strong>Select Routes</strong>
                              <button
                                className="btn btn-sm btn-light"
                                onClick={toggleDropdown}
                              >
                                ×
                              </button>
                            </div>

                            <div className="dropdown-item py-1" >
                              <div className="form-check d-flex align-items-center" >
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  style={{
                                    opacity: 0,
                                    position: "absolute",
                                    left: "10px",
                                  }}
                                  id="allRoutesCheckbox"
                                  value="all"
                                  checked={selectedRoutes.includes("all")}
                                  onChange={() => handleRouteSelection("all")}
                                />
                                <label
                                  className="form-check-label ms-3"
                                  htmlFor="allRoutesCheckbox"
                                  style={{ paddingLeft: "24px" }}
                                >
                                  All Routes
                                </label>
                              </div>
                            </div>

                            {allRoutes.map((route) => (
                              <div key={route} className="dropdown-item py-1" >
                                <div className="form-check d-flex align-items-center" >
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    style={{
                                      opacity: 0,
                                      position: "absolute",
                                      left: "10px",
                                    }}
                                    id={`routeCheckbox-${route}`}
                                    value={route}
                                    checked={isRouteSelected(route)}
                                    onChange={() => handleRouteSelection(route)}
                                  />
                                  <label
                                    className="form-check-label ms-3"
                                    htmlFor={`routeCheckbox-${route}`}
                                    style={{ paddingLeft: "24px" }}
                                  >
                                    {route}
                                  </label>
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-4 col-12">
                      <input
                        className="form-control"
                        value={dealerFilter}
                        onChange={(e) => setDealerFilter(e.target.value)}
                        placeholder="Enter Dealer Name..."
                      />
                    </div>

                    

                    <div className="col-auto mb-2">
                      <button
                        className="btn btn-sm btn-warning"
                        onClick={exportToExcel}
                      >
                        <i className="fa fa-download"></i> Excel
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="box-body">
                <div
                  className="table-responsive"
                  style={{
                    width: "100%",
                    height: "calc(100vh - 290px)",
                    overflow: "auto",
                    padding: "0 10px 10px 10px",
                  }}
                >
                  <table
                    style={{ whiteSpace: "nowrap" }}
                    className="table-sm table-bordered nowrap fs-10"
                    id="printableArea"
                    width="100%"
                  >
                    <thead>
                      <tr
                        className="text-dark text-center"
                        style={{
                          position: "sticky",
                          top: 0,
                          zIndex: 2,
                          backgroundColor: "#f8f9fa",
                        }}
                      >
                        <th rowspan="2">Invoice Date</th>
                        <th rowspan="2">Invoice No.</th>
                        <th rowspan="2">Dealer</th>
                        <th rowspan="2">Routes</th>
                        <th rowspan="2">GST No.</th>
                        <th colSpan={3}>MILK Sales</th>
                        <th colSpan={3}>CURD Sales</th>
                        <th rowspan="2">Net Total</th>
                        <th rowspan="2">IGST</th>
                        <th rowspan="2">CGST</th>
                        <th rowspan="2">SGST</th>
                        <th rowspan="2">Trade Discount</th>
                        <th rowspan="2">Round-Off</th>
                        <th rowspan="2">Invoice Amount</th>
                      </tr>
                      <tr
                        className="text-dark text-center"
                        style={{
                          position: "sticky",
                          top: "25px",
                          zIndex: 1,
                          backgroundColor: "#f8f9fa",
                        }}
                      >
                        <th>LTR</th>
                        <th>SGST SALES</th>
                        <th>IGST SALES</th>
                        <th>KG</th>
                        <th>SGST SALES</th>
                        <th>IGST SALES</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filterdData?.length > 0 ? (
                        <>
                          {filterdData
                            .slice()
                            .reverse()
                            .map((item, index) => {
                              const iGSTMilk = getGSTItem(
                                item?.orderData,
                                item?.dealerData,
                                "IGST",
                                "milk"
                              );
                              const iGSTCurd = getGSTItem(
                                item?.orderData,
                                item?.dealerData,
                                "IGST",
                                "curd"
                              );
                              const sGSTMilk = getGSTItem(
                                item?.orderData,
                                item?.dealerData,
                                "SGST",
                                "milk"
                              );
                              const sGSTCurd = getGSTItem(
                                item?.orderData,
                                item?.dealerData,
                                "SGST",
                                "curd"
                              );
                              const sgstTotal = parseFloat(
                                getGstTotal(
                                  item?.orderData,
                                  item?.dealerData,
                                  "SGST"
                                ) || 0
                              );
                              const igstTotal = parseFloat(
                                getGstTotal(
                                  item?.orderData,
                                  item?.dealerData,
                                  "IGST"
                                ) || 0
                              );
                              const discount = parseFloat(item?.discount || 0);

                              const milkWeight = getWeight(
                                "milk",
                                item?.orderData
                              );
                              const curdWeight = getWeight(
                                "curd",
                                item?.orderData
                              );

                              const orderTotal = parseFloat(
                                getTotal(item?.orderData)
                              );
                              const sgst = (sgstTotal * 0.025).toFixed(2);
                              const igst = (igstTotal * 0.05).toFixed(2);
                              const totalPayment = parseFloat(
                                parseFloat(orderTotal) +
                                  parseFloat(sgst) +
                                  parseFloat(igst) +
                                  parseFloat(sgst)
                              );

                              const roundOff = (
                                Math.round(totalPayment - discount) -
                                (totalPayment - discount)
                              ).toFixed(2);
                              const finalPayment = Math.round(
                                totalPayment - discount
                              ).toFixed(2);

                              igstMilkTotal += parseFloat(iGSTMilk) || 0;
                              sgstMilkTotal += parseFloat(sGSTMilk) || 0;
                              igstCurdTotal += parseFloat(iGSTCurd) || 0;
                              sgstCurdTotal += parseFloat(sGSTCurd) || 0;
                              netTotTotal += parseFloat(orderTotal) || 0;
                              iGstTotal += parseFloat(igst) || 0;
                              sGstToatl += parseFloat(sgst) || 0;
                              dicsTotal += parseFloat(discount) || 0;
                              grandTotTotal += parseFloat(finalPayment) || 0;
                              milkWeightTotal += parseFloat(milkWeight) || 0;
                              curdWeightTotal += parseFloat(curdWeight) || 0;
                              roundOffTotal += parseFloat(roundOff) || 0;

                              return (
                                <tr key={index}>
                                  <td data-t="s">{formatViewDate(item?.date)}</td>
                                  <td>{`TRC/${item?.invoiceId}/${getFiscalYearLabel(
                                    new Date(item?.date)
                                  )}`}</td>
                                  <td>{item?.dealerData?.dealer}</td>
                                  <td>{item?.routeName}</td>
                                  <td>{item?.dealerData?.gst}</td>
                                  <td className="text-end">
                                    {milkWeight > 0
                                      ? Number(milkWeight).toFixed(2)
                                      : ""}
                                  </td>
                                  <td className="text-end">{sGSTMilk}</td>
                                  <td className="text-end">{iGSTMilk}</td>
                                  <td className="text-end">
                                    {curdWeight > 0
                                      ? Number(curdWeight).toFixed(2)
                                      : ""}
                                  </td>
                                  <td className="text-end">{sGSTCurd}</td>
                                  <td className="text-end">{iGSTCurd}</td>
                                  <td className="text-end">
                                    {orderTotal.toFixed(2)}
                                  </td>
                                  <td className="text-end">
                                    {igstTotal > 0 ? igst : ""}
                                  </td>
                                  <td className="text-end">
                                    {sgstTotal > 0 ? sgst : ""}
                                  </td>
                                  <td className="text-end">
                                    {sgstTotal > 0 ? sgst : ""}
                                  </td>
                                  <td className="text-end">
                                    {discount > 0 ? discount.toFixed(2) : ""}
                                  </td>
                                  <td className="text-end">
                                    {parseFloat(roundOff) !== 0
                                      ? parseFloat(roundOff).toFixed(2)
                                      : ""}
                                  </td>
                                  <td className="text-end">{finalPayment}</td>
                                </tr>
                              );
                            })}

                          <tr class="bg-light font-weight-bold">
                            <th className="text-start" colspan="5">
                              Total
                            </th>
                            <th className="text-end">
                              {milkWeightTotal.toFixed(2)}
                            </th>
                            <th className="text-end">
                              {sgstMilkTotal.toFixed(2)}
                            </th>
                            <th className="text-end">
                              {igstMilkTotal.toFixed(2)}
                            </th>
                            <th className="text-end">
                              {curdWeightTotal.toFixed(2)}
                            </th>
                            <th className="text-end">
                              {sgstCurdTotal.toFixed(2)}
                            </th>
                            <th className="text-end">
                              {igstCurdTotal.toFixed(2)}
                            </th>
                            <th className="text-end">
                              {netTotTotal.toFixed(2)}
                            </th>
                            <th className="text-end">{iGstTotal.toFixed(2)}</th>
                            <th className="text-end">{sGstToatl.toFixed(2)}</th>
                            <th className="text-end">{sGstToatl.toFixed(2)}</th>
                            <th className="text-end">{dicsTotal.toFixed(2)}</th>
                            <th className="text-end">{parseFloat(roundOffTotal).toFixed(2)}</th>
                            <th className="text-end">
                              {grandTotTotal.toFixed(2)}
                            </th>
                          </tr>
                        </>
                      ) : (
                        <tr>
                          <td colSpan="14" className="text-center">
                            No Data Available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}

export default LedgerReport;
